import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

import ALandingPage from "./LandingPage/ALandingPage";
import RegisterPage from "./auth/RegisterPage";
import LoginPage from "./auth/LoginPage";
import ForgotPasswordPage from "./auth/ForgotPasswordPage";
import ResetPasswordPage from "./auth/ResetPasswordPage";
import EmailVerificationPage from "./auth/EmailVerificationPage";
import WelcomeScreen from "./auth/WelcomeScreen";
import VideoDemosPage from "./LandingPage/VideoDemosPage";
import IronworkerDashboard from "./OrganizationDashboard/WorkerCRM";
import AcceptInvitationPage from "./OrganizationDashboard/AcceptInvitationPage";
import ContactsCRM from "./OrganizationDashboard/ContactsCRM";

// Dashboard components for each user type:
import OrganizationDashboard from "./OrganizationDashboard/OrganizationDashboard";
import FormanDashboard from "./FormanDashboard/FormanDashboard";
import ProjectManagerDashboard from "./ProjectManagerDashboard/ProjectManagerDashboard";

// Onboarding for organizations
import OnboardingFlow from "./Onboarding/OnboardingFlow";



function MyteConstructionApp() {
  // This hook will auto logout the user after 5 minutes of inactivity.

  const { auth } = useContext(AuthContext);
  const isLoggedIn = !!auth.token;

  // Determine which dashboard component to show based on user type and onboarding status.
  let dashboardComponent;
  if (auth.user_type === "Organization") {
    dashboardComponent = auth.hasCompletedOnboarding ? (
      <OrganizationDashboard />
    ) : (
      <Navigate to="/myteconstruction/onboarding" />
    );
  } else if (auth.user_type === "Foreman") {
    dashboardComponent = <FormanDashboard />;
  } else if (auth.user_type === "Project Manager") {
    dashboardComponent = <ProjectManagerDashboard />;
  } else {
    dashboardComponent = (
      <div>Dashboard not implemented for this user type.</div>
    );
  }

  return (
    <Routes>
      {/* Public (unprotected) routes */}
      <Route path="/" element={<ALandingPage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="forgot" element={<ForgotPasswordPage />} />
      <Route path="reset" element={<ResetPasswordPage />} />
      <Route path="verify" element={<EmailVerificationPage />} />
      <Route path="welcome" element={<WelcomeScreen />} />
      <Route path="video-demos" element={<VideoDemosPage />} />

      {/* Organization Onboarding: Only for Organization user type */}
      <Route
        path="onboarding"
        element={
          !isLoggedIn ? (
            <Navigate to="/myteconstruction/login" />
          ) : auth.user_type === "Organization" &&
            !auth.hasCompletedOnboarding ? (
            <OnboardingFlow />
          ) : (
            <Navigate to="/myteconstruction/dashboard" />
          )
        }
      />

      {/* Dashboard: Render the dashboard based on user type */}
      <Route
        path="dashboard/*"
        element={
          !isLoggedIn ? (
            <Navigate to="/myteconstruction/login" />
          ) : (
            dashboardComponent
          )
        }
      />

      {/* Additional dashboard routes for Foreman and Project Manager */}
      <Route path="foreman-dashboard" element={<FormanDashboard />} />
      <Route path="project-manager-dashboard" element={<ProjectManagerDashboard />} />

      {/* Protect ironworkers route */}
      <Route
        path="ironworkers"
        element={
          !isLoggedIn ? (
            <Navigate to="/myteconstruction/login" />
          ) : !auth.hasCompletedOnboarding ? (
            <Navigate to="/myteconstruction/onboarding" />
          ) : (
            <IronworkerDashboard />
          )
        }
      />

      {/* Contacts CRM route */}
      <Route path="dashboard/contacts" element={<ContactsCRM />} />

      {/* Invitation acceptance */}
      <Route path="invite/accept" element={<AcceptInvitationPage />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/myteconstruction" />} />
    </Routes>
  );
}

export default MyteConstructionApp;
